/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import DoneIcon from '@mui/icons-material/Done';
import RefreshIcon from "@mui/icons-material/Refresh";
import { FormControl, InputLabel, MenuItem, Select, } from "@mui/material";
import Grid from "@mui/material/Grid";
import PickDate from "components/DatePicker/DatePicker";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { lazy, Suspense, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import { getBUDashboardBillsYouNeedToPayGraphs, getBUDashboardInvoicesOwedToYouGraphDetails, getBusinessUserDasboardLineChartDataOrderRevenue, getBusinessUserDashboardCardData, getDefaultSetting } from "utils/api";
import { appConstants } from "utils/appConstants";
import PriceCheck from '@mui/icons-material/PriceCheck';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import DescriptionIcon from '@mui/icons-material/Description';
import ReceiptTwoToneIcon from '@mui/icons-material/ReceiptTwoTone';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import GridViewIcon from '@mui/icons-material/GridView';
import GroupIcon from '@mui/icons-material/Group';
import TimeAgo from './TimeAgo';
import { showResMsg } from "utils/generic";
import { useMaterialUIController } from 'context';
import CustomText from 'components/customtext/customtext';
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import { set } from 'date-fns';
import { Link } from 'react-router-dom';
import { formatCurrencyAUD } from 'utils/formatCurrency';
const Projects = lazy(() => import("layouts/businessUserDashboard/components/Projects"));

function abbreviateCount(number) {
  const SI_SYMBOL = ["", "K", "M", "B", "T"];
  const tier = Math.log10(Math.abs(number)) / 3 | 0;
  if (tier === 0) return number;
  const suffix = SI_SYMBOL[tier];
  const scale = Math.pow(10, tier * 3);
  const scaled = number / scale;
  return scaled.toFixed(2) + suffix;
}


function BusinessUserDashboard() {
  const customerReload = useRef(null);
  let userDetails = JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"));
  const [totalItemCount, setTotalItemCount] = useState(0);
  const [totalInvoiceCount, setTotalInvoiceCount] = useState(0);
  const [totalQuotationsCount, setTotalQuotationsCount] = useState(0);
  const [totalRctiCount, setTotalRctiCount] = useState(0);
  const [totalUserCount, setTotalUserCount] = useState(0);
  const [totalCustomerCount, setTotalCustomerCount] = useState(0);
  const [totalSupplierCount, setTotalSupplierCount] = useState(0);
  const [totalUnpaidInvoiceAmount, setTotalUnpaidInvoiceAmount] = useState(0);
  const [totalUnpaidRctiCount, setTotalUnpaidRctiCount] = useState(0);
  const [totalRCTIDraftAmount, setTotalRCTIDraftAmount] = useState(0);
  const [totalRCTIDraftCount, setTotalRCTIDraftCount] = useState(0);
  const [totalRCTIAwaitingPaymentAmount, setTotalRCTIAwaitingPaymentAmount] = useState(0);
  const [totalRCTIAwaitingPaymentCount, setTotalRCTIAwaitingPaymentCount] = useState(0);
  const [totalRCTIOverdueAmount, setTotalRCTIOverdueAmount] = useState(0);
  const [totalRCTIOverdueCount, setTotalRCTIOverdueCount] = useState(0);
  let currency = useSelector((state) => state.currency.currencySymbol);
  const [totalDebtCount, setTotalDebtCount] = useState(0);
  const [totalInvoiceDraftCount, setTotalInvoiceDraftCount] = useState(0);
  const [totalInvoiceDraftAmount, setTotalInvoiceDraftAmount] = useState(0);
  const [totalAwaitingPaymentAmount, setTotalAwaitingPaymentAmount] = useState(0);
  const [totalAwaitingPaymentCount, setTotalAwaitingPaymentCount] = useState(0);
  const [totalOverdueAmount, setTotalOverdueAmount] = useState(0);
  const [totalOverdueCount, setTotalOverdueCount] = useState(0);
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const currentDate = new Date();
  const [chartDataTotalBusinessUserCusromer, setChartDataTotalBusinessUserCustomer] = useState([]);
  const [chartDataTotalBusinessUserTotalOrders, setChartDataTotalBusinessUserTotalOrders] = useState([]);
  const [chartDataTotalBusinessUserTotalOrdersRevenue, setChartDataTotalBusinessUserTotalOrdersRevenue] = useState([]);
  const labels = [];
  const [values, setValues] = useState({
    dashboardDuration: "lastWeek",
    businessUserID: userDetails.businessUserID,
    page: appConstants.page,
    limit: appConstants.limit,
    sortingType: "",
    sortingField: "",
    customFrom: new Date(new Date().setDate(new Date().getDate() - 1)),
    customTo: new Date(),
  });
  const [timestamp, setTimestamp] = useState(new Date().getTime());
  const dispatch = useDispatch();

  useEffect(() => {
    const fieldsets = document.querySelectorAll('fieldset');
    const labels = document.querySelectorAll('.MuiInputLabel-outlined');
    const borderColor = darkMode ? 'white' : tableBorder;

    labels.forEach(label => { label.style.color = borderColor; });
    fieldsets.forEach(fieldset => { fieldset.style.borderColor = borderColor; });

    if (values.dashboardDuration !== "custom") {
      fetchBusinessUserDashboardData();
    }

  }, [values.dashboardDuration]);

  useEffect(() => {

    Promise.all([
      //fetchBusinessUserDashboardData()
      fetchBusinessUserDasboardBarChartData(),
      fetchBusinessUserDasboardLineChartData(),
      fetchBusinessUserDasboardLineChartDataOrderRevenue(),
    ]);
    fetchBusinessUserDefaultSetting();
  }, [dispatch]);

  function getLabels() {
    const currentDate = new Date();

    function getWeekDates(date) {
      const weekStart = new Date(date);
      weekStart.setDate(date.getDate() - date.getDay());
      weekStart.setUTCHours(0, 0, 0, 0);

      const weekEnd = new Date(weekStart);
      weekEnd.setDate(weekStart.getDate() + 6);
      weekEnd.setUTCHours(0, 0, 0, 0);

      return { start: weekStart, end: weekEnd };
    }

    function generateLabels(currentDate) {
      const labels = [];

      const thisWeekDates = getWeekDates(currentDate);
      const lastWeekDates = getWeekDates(new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000));
      const nextWeekDates = getWeekDates(new Date(currentDate.getTime() + 7 * 24 * 60 * 60 * 1000));

      const weekAfterNextDates = getWeekDates(new Date(currentDate.getTime() + 14 * 24 * 60 * 60 * 1000));

      if (currentDate.getTime() < nextWeekDates.start.getTime()) {
        labels.push("Older");
      }

      labels.push(
        `${lastWeekDates.start.getDate()}-${lastWeekDates.end.getDate()} ${lastWeekDates.end.toLocaleString('default', { month: 'short' })}`,
        "This Week",
        `${nextWeekDates.start.getDate()}-${nextWeekDates.end.getDate()} ${nextWeekDates.end.toLocaleString('default', { month: 'short' })}`,
        `${weekAfterNextDates.start.getDate()}-${weekAfterNextDates.end.getDate()} ${weekAfterNextDates.end.toLocaleString('default', { month: 'short' })}`,
        "Future"
      );
      return labels;
    }
    return generateLabels(currentDate);
  }

  const getMonthLabel = useCallback(() => {
    const labels = [];
    for (let i = 5; i >= 0; i--) {
      const date = new Date(currentDate);
      date.setMonth(date.getMonth() - i);
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      labels.push(monthNames[date.getMonth()]);
    }
    return labels;
  }, [currentDate]);

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };
  const handleDateChange = (name) => (date) => {
    setValues({ ...values, [name]: new Date(date) });

  };

  const handleRefreshButtonClick = () => {
    fetchBusinessUserDashboardData();

    if (customerReload.current) {
      setTimestamp(new Date().getTime())
      customerReload.current.fetchBusinessUserCustomerGridData();
    }
  };
  const fetchBusinessUserDefaultSetting = async () => {
    getDefaultSetting(values, (data) => {
      if (!data.Result_Status) {
        swal({
          title: "Please configure the Default Settings",
          text: "Click the button below to configure your default settings.",
          icon: "warning",
          closeOnClickOutside: false,
          closeOnEsc: false,
          buttons: {
            confirm: {
              text: "Go to Default Settings",
              value: true,
              visible: true,
              closeModal: true,
              className: "btn-block center-container-btn btn-warning",
            },
          },
        }).then((value) => {
          if (value) {
            window.location.href = "/defaultSettings";
          }
        });
      }
    },
      dispatch
    );
  };
  const fetchBusinessUserDashboardData = useCallback(async () => {
    let toDate = new Date(values.customTo);
    toDate.setUTCHours(0, 0, 0, 0);
    let fromDate = new Date(values.customFrom);
    fromDate.setUTCHours(0, 0, 0, 0);

    if (toDate < fromDate) {
      return showResMsg("To Date should not be less than from date.", 2000, false);
    }

    const processDashboardData = (data) => {
      let resData = data.output[0];
      console.log("Dashboard Data:", resData);
      if (resData.invoicesCount?.length > 0) {
        setTotalInvoiceCount(resData.invoicesCount[0].TotalInvoiceCount);
        setTotalUnpaidInvoiceAmount(resData.invoicesCount[0].TotalUnpaidAmount);
        setTotalDebtCount(resData.invoicesCount[0].TotalDebtCount);
        setTotalInvoiceDraftAmount(resData.invoicesCount[0].TotalInvoiceDraftAmount);
        setTotalInvoiceDraftCount(resData.invoicesCount[0].TotalInvoiceDraftCount);
        setTotalAwaitingPaymentAmount(resData.invoicesCount[0].TotalAwaitingPaymentAmount);
        setTotalAwaitingPaymentCount(resData.invoicesCount[0].TotalAwaitingPaymentCount);
        setTotalOverdueAmount(resData.invoicesCount[0].TotalOverduePaymentAmount);
        setTotalOverdueCount(resData.invoicesCount[0].TotalOverduePaymentCount);
      }

      if (resData.itemsCount?.length > 0) {
        setTotalItemCount(resData.itemsCount[0].TotalItemCount);
      }

      if (resData.quotationsCount?.length > 0) {
        setTotalQuotationsCount(resData.quotationsCount[0].TotalQuotationCount);
      }

      if (resData.rctiCount?.length > 0) {
        setTotalRctiCount(resData.rctiCount[0].TotalRctiCount);
        setTotalUnpaidRctiCount(resData.rctiCount[0].TotalRctiUnpaidAmount);
        setTotalRCTIDraftAmount(resData.rctiCount[0].TotalRCTIDraftAmount);
        setTotalRCTIDraftCount(resData.rctiCount[0].TotalRCTIDraftCount);
        setTotalRCTIAwaitingPaymentAmount(resData.rctiCount[0].TotalAwaitingRCTIPaymentAmount);
        setTotalRCTIAwaitingPaymentCount(resData.rctiCount[0].TotalAwaitingRCTIPaymentCount);
        setTotalRCTIOverdueAmount(resData.rctiCount[0].TotalOverdueRCTIPaymentAmount);
        setTotalRCTIOverdueCount(resData.rctiCount[0].TotalOverdueRCTIPaymentCount);
      }

      if (resData.usersCount?.length > 0) {
        setTotalUserCount(resData.usersCount[0].TotalUserCount);
      }

      if (resData.contactsCount?.length > 0) {
        setTotalCustomerCount(resData.contactsCount[0].TotalCustomerCount);
        setTotalSupplierCount(resData.contactsCount[0].TotalSupplierCount);
      }
    };
    getBusinessUserDashboardCardData(values, processDashboardData, dispatch);

  }, [values, showResMsg, dispatch]);

  const handleCustomDateSearch = useCallback(() => {
    fetchBusinessUserDashboardData();
  }, [fetchBusinessUserDashboardData]);

  const fetchBusinessUserDasboardBarChartData = async () => {
    getBUDashboardInvoicesOwedToYouGraphDetails(
      values,
      (data) => {

        if (data.Result_Status) {
          const counts = data.Result_Output.map(item => item);
          setChartDataTotalBusinessUserCustomer([counts]);
        } else {
          console.error("Error: Unable to Fetch 'Invoices Owed To You' Graph Details.");
        }
      },
      dispatch
    );
  };
  const fetchBusinessUserDasboardLineChartData = async () => {
    getBUDashboardBillsYouNeedToPayGraphs(
      values,
      (data) => {
        if (data.Result_Status) {
          const counts = data.Result_Output.map(item => item);
          setChartDataTotalBusinessUserTotalOrders([counts]);
        } else {
          console.error("Error: Unable to Fetch 'Bills You Need To Pay' Graph Details.");
        }
      },
      dispatch
    );
  };
  const fetchBusinessUserDasboardLineChartDataOrderRevenue = async () => {
    getBusinessUserDasboardLineChartDataOrderRevenue(
      values,
      (data) => {
        if (data && data.output && Array.isArray(data.output.Invoice_revenue) && Array.isArray(data.output.RCTI_revenue)) {
          const Invoicecounts = data.output.Invoice_revenue.map(item => item.count);
          const RCTIcounts = data.output.RCTI_revenue.map(item => item.count);

          setChartDataTotalBusinessUserTotalOrdersRevenue([Invoicecounts, RCTIcounts]);
        } else {
          console.error("Error: Data structure is invalid or missing.");
        }
      },
      dispatch
    );
  };


  const getSentDate = useCallback((values) => {
    let startDate, endDate;

    if (values.dashboardDuration === "custom") {
      startDate = new Date(values.customFrom);
      startDate.setUTCHours(0, 0, 0, 0);
      endDate = new Date(values.customTo);
      endDate.setUTCHours(23, 59, 59, 999);

    } else {
      const today = new Date();
      today.setUTCHours(0, 0, 0, 0);

      if (values.dashboardDuration === "today") {
        startDate = new Date(today);
        endDate = new Date(today);
        endDate.setUTCHours(23, 59, 59, 999);

      } else if (values.dashboardDuration === "lastWeek") {
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 7);
        endDate = new Date(today);
        endDate.setUTCHours(23, 59, 59, 999);

      } else if (values.dashboardDuration === "lastMonth") {
        startDate = new Date(today);
        startDate.setMonth(today.getMonth() - 1);
        endDate = new Date(today);
        endDate.setUTCHours(23, 59, 59, 999);

      } else if (values.dashboardDuration === "lastYear") {
        startDate = new Date(today);
        startDate.setFullYear(today.getFullYear() - 1);
        endDate = new Date(today);
        endDate.setUTCHours(23, 59, 59, 999);
      }
    }
    return { startDate, endDate };
  }, [values.dashboardDuration, values.customFrom, values.customTo]);

  const { startDate, endDate } = getSentDate(values);

  const formatDate = useCallback((date) => {
    console.log("render formatate");
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }, []);

  const formattedStartDate = useMemo(() => startDate ? formatDate(startDate) : '', [startDate, formatDate]);
  const formattedEndDate = useMemo(() => endDate ? formatDate(endDate) : '', [endDate, formatDate]);


  const statisticsCards = useMemo(() => [
    {
      color: "primary",
      icon: <PriceCheck className="large-icon" />,
      title: "To Receive",
      link: `/invoices?invoiceStatus=Unpaid&&duration=${values.dashboardDuration}&&from=${formattedStartDate}&&to=${formattedEndDate}`,
      count: abbreviateCount(formatCurrencyAUD(formatCurrencyAUD(parseFloat(totalUnpaidInvoiceAmount).toFixed(2)))),

    },
    {
      color: "info",
      icon: <AttachMoneyIcon />,
      title: "To be Paid",
      link: `/rcti?rctiStatus=Unpaid&&duration=${values.dashboardDuration}&&from=${formattedStartDate}&&to=${formattedEndDate}`,
      count: abbreviateCount(formatCurrencyAUD(parseFloat(totalUnpaidRctiCount).toFixed(2))),

    },
    // {
    //   color: "success",
    //   icon: <PendingActionsIcon />,
    //   title: "Quotations",
    //   link: `/quotations?rdt=dashboard&&duration=${values.dashboardDuration}&&from=${formattedStartDate}&&to=${formattedEndDate}`,
    //   count: totalQuotationsCount,
    // },
    {
      color: "dark",
      icon: <DescriptionIcon />,
      title: "Invoices",
      link: `/invoices?rdt=dashboard&&duration=${values.dashboardDuration}&&from=${formattedStartDate}&&to=${formattedEndDate}`,
      count: totalInvoiceCount,
      titletext: `${totalInvoiceDraftCount} Draft Invoices ${formatCurrencyAUD(totalInvoiceDraftAmount)}`,
      titletext1: `${totalAwaitingPaymentCount} Awaiting Payment ${formatCurrencyAUD(totalAwaitingPaymentAmount)}`,
      titletext2: `${totalOverdueCount} Overdue ${formatCurrencyAUD(totalOverdueAmount)}`,
      titletext3: (
        <Link
          to="/invoices/add?type=new"
          style={{ color: "#1976d2", textDecoration: "underline", cursor: "pointer", fontSize: "16px", fontWeight: "bold" }}
        >
          Add new Invoice
        </Link>
      ),
    },
    // { 
    //   color: "warning",
    //   icon: <CreditCardIcon />,
    //   title: "Debt",
    //   link: `/debts?rdt=dashboard&&duration=${values.dashboardDuration}&&from=${formattedStartDate}&&to=${formattedEndDate}`,
    //   count: totalDebtCount,
    // },
    {
      color: "success",
      icon: <ReceiptTwoToneIcon />,
      title: "RCTI",
      link: `/rcti?rdt=dashboard&&duration=${values.dashboardDuration}&&from=${formattedStartDate}&&to=${formattedEndDate}`,
      count: totalRctiCount,
      titletext: `${totalRCTIDraftCount} Draft Bill ${formatCurrencyAUD(totalRCTIDraftAmount)}`,
      titletext1: `${totalRCTIAwaitingPaymentCount} Awaiting Payment ${formatCurrencyAUD(totalRCTIAwaitingPaymentAmount)}`,
      titletext2: `${totalRCTIOverdueCount} Overdue ${formatCurrencyAUD(totalRCTIOverdueAmount)}`,
      titletext3: (
        <Link
          to="/rcti/add?type=new"
          style={{ color: "#1976d2", textDecoration: "underline", cursor: "pointer", fontSize: "16px", fontWeight: "bold" }}
        >
          Add new RCTI
        </Link>
      ),
    },
    // {
    //   color: "error",
    //   icon: <PeopleAltIcon />,
    //   title: "Customers",
    //   link: `/contacts?rdt=dashboard&ctype=Customer&&contactStatus=Active&&duration=${values.dashboardDuration}&&from=${formattedStartDate}&&to=${formattedEndDate}`,
    //   count: totalCustomerCount,
    // },
    // {
    //   color: "secondary",
    //   icon: <PeopleAltIcon />,
    //   title: "Suppliers",
    //   link: `/contacts?rdt=dashboard&ctype=Supplier&&contactStatus=Active&&duration=${values.dashboardDuration}&&from=${formattedStartDate}&&to=${formattedEndDate}`,
    //   count: totalSupplierCount,
    // },
    // {
    //   color: "primary",
    //   icon: <GridViewIcon />,
    //   title: "Items",
    //   link: `/items?rdt=dashboard&&duration=${values.dashboardDuration}&&from=${formattedStartDate}&&to=${formattedEndDate}`,
    //   count: totalItemCount,
    // },
    // {
    //   color: "success",
    //   icon: <GroupIcon />,
    //   title: "Users",
    //   link: `/myusers?rdt=dashboard&&duration=${values.dashboardDuration}&&from=${formattedStartDate}&&to=${formattedEndDate}`,
    //   count: totalUserCount,
    // },
  ], [
    values.dashboardDuration,
    formattedStartDate,
    formattedEndDate,
    totalUnpaidInvoiceAmount,
    totalUnpaidRctiCount,
    totalRCTIDraftAmount,
    totalRCTIDraftCount,
    totalRCTIAwaitingPaymentAmount,
    totalRCTIAwaitingPaymentCount,
    totalRCTIOverdueAmount,
    totalRCTIOverdueCount,
    totalQuotationsCount,
    totalInvoiceCount,
    totalDebtCount,
    totalInvoiceDraftCount,
    totalInvoiceDraftAmount,
    totalAwaitingPaymentAmount,
    totalAwaitingPaymentCount,
    totalOverdueAmount,
    totalOverdueCount,
    totalRctiCount,
    totalCustomerCount,
    totalSupplierCount,
    totalItemCount,
    totalUserCount,
  ]);

  return (
    <DashboardLayout >
      <DashboardNavbar />

      <Grid container sx={{ display: "flex", justifyContent: "center", paddingBottom: "10px" }}>

        <Grid item lg={7} md={6} xs={12} mt={2}>
          {values.dashboardDuration === "custom" && (

            <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'end', }}>
              <Grid item lg={4} md={5} xs={5}>
                <PickDate
                  selected={new Date(values.customFrom)}
                  onChange={handleDateChange('customFrom')}
                  label="From"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                />
              </Grid>
              <Grid item lg={4} md={5} xs={5}>
                <PickDate
                  selected={new Date(values.customTo)}
                  onChange={handleDateChange('customTo')}
                  label="To"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  maxDate={new Date()}
                />
              </Grid>
              <Grid item lg={1.5} md={2} xs={2} sx={{ display: "flex", justifyContent: "flex-end", }} >
                <MDButton
                  rel="noreferrer"
                  variant="gradient"
                  color="success"
                  onClick={handleCustomDateSearch}
                >
                  <DoneIcon className="largeFont" color="light" sx={{ cursor: "pointer" }} />
                </MDButton>
              </Grid>
            </Grid>
          )}
        </Grid>

        <Grid item lg={5} md={6} xs={12} mt={2} sx={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>

          <Grid item lg={4} md={4} xs={12} >
            <FormControl fullWidth style={{ marginLeft: "10px" }}>
              <InputLabel id="Status">Duration</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                style={{ height: "38.11px" }}
                label="Duration  "
                value={values.dashboardDuration}
                onChange={handleChange('dashboardDuration')}
              >
                <MenuItem value="today">Today</MenuItem>
                <MenuItem value="lastWeek">Last 7 Days</MenuItem>
                <MenuItem value="lastMonth">Last 30 Days</MenuItem>
                <MenuItem value="lastYear">Last 12 months</MenuItem>
                <MenuItem value="custom"> Custom Date</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={4} md={4} xs={6} sx={{ display: "flex", justifyContent: "flex-end", paddingRight: "10px" }}>
            <CustomText type="p"  >
              Last updated
              <br />
              <TimeAgo timestamp={timestamp} />
            </CustomText>
          </Grid>
          <Grid item lg={1.5} md={2} xs={6} sx={{ display: "flex", justifyContent: "flex-end", }}>
            <MDButton
              rel="noreferrer"
              variant="gradient"
              color="success"
              style={{ height: "38.11px !important" }}
              // fullWidth
              onClick={handleRefreshButtonClick}
            >
              <RefreshIcon color="light" sx={{ cursor: "pointer" }} />
            </MDButton>
          </Grid>
        </Grid>
      </Grid>

      <MDBox py={3} >
        <Grid container columnSpacing={3} rowSpacing={2} >
          {statisticsCards.map((card, index) => (
            <Grid key={index} item xs={12} md={6} lg={3} >
              <MDBox mb={5}>
                <ComplexStatisticsCard
                  color={card.color}
                  icon={card.icon}
                  title={card.title}
                  titletext={card.titletext}
                  titletext1={card.titletext1}
                  titletext2={card.titletext2}
                  titletext3={card.titletext3}
                  link={card.link}
                  // count={card.count}
                  // count={`${card.count}`}
                  count={
                    card.title === "To Receive" || card.title === "To be Paid" ? (
                      <a href={card.link} style={{ textDecoration: "none", color: "inherit" }}>
                        {currency}{card.count}
                      </a>
                    ) : (
                      `${card.count}`
                    )
                  }

                />
              </MDBox>
            </Grid>
          ))}
        </Grid>

        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="info"
                  title="To Receive"

                  chart={{
                    labels: getLabels(),
                    datasets: {
                      label: ["Unpaid Invoices"],
                      backgroundColor: ["rgba(255, 255, 255, 0.8)"],
                      data: chartDataTotalBusinessUserCusromer,
                    },

                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="success"
                  title="To be Paid"
                  chart={{
                    labels: getLabels(),
                    datasets: {
                      label: ["Unpaid RCTI"],
                      backgroundColor: ["rgba(255, 255, 255, 0.8)"],
                      data: chartDataTotalBusinessUserTotalOrders,
                    },
                  }}
                />

              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="dark"
                  title="Total cash in and out"
                  chart={{
                    labels: getMonthLabel(),
                    datasets: {
                      label: ["Invoices Revenue", "RCTI Revenue"],
                      backgroundColor: ["rgba(73, 163, 241, 0.8)", "rgba(142, 213, 87, 0.8)"],
                      data: chartDataTotalBusinessUserTotalOrdersRevenue,
                    },
                  }}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        {/* Customers Table */}
        {/* <MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={12}>
              <Suspense fallback={<div>fetching customer stats...</div>}>
                <Projects ref={customerReload} />
              </Suspense>
            </Grid>

          </Grid>
        </MDBox> */}
      </MDBox>
    </DashboardLayout>
  );
}

export default BusinessUserDashboard;
